import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FolderKanban, FileText, Receipt, LifeBuoy, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";

export default function Dashboard() {
  const { user } = useAuth();
  const { t, lang, sl } = useI18n();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/customer").then((r) => setD(r.data)).catch(() => {}); }, []);
  const cards = [
    [t("portal.activeProjects"), d?.active_projects, FolderKanban, "/portal/projects"],
    [t("portal.openOffers"), d?.open_offers, FileText, "/portal/offers"],
    [t("portal.unpaidInvoices"), d?.unpaid_invoices, Receipt, "/portal/invoices"],
    [t("portal.openTickets"), d?.open_tickets, LifeBuoy, "/portal/tickets"],
  ];
  return (
    <div className="space-y-8" data-testid="portal-dashboard">
      <div>
        <h1 className="font-display text-3xl font-black tracking-tight">{t("portal.welcome")}, {user?.first_name || user?.name} 👋</h1>
        <p className="text-muted-foreground mt-1">{lang === "de" ? "Hier ist Ihre Übersicht." : "Here is your overview."}</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map(([label, val, Icon, to]) => (
          <Link key={label} to={to} className="surface p-6 hover:border-primary transition-colors" data-testid={`stat-${to.split("/").pop()}`}>
            <div className="flex items-center justify-between">
              <Icon size={22} className="text-primary" />
              <ArrowRight size={16} className="text-muted-foreground" />
            </div>
            <div className="font-display text-3xl font-black mt-4">{val ?? "—"}</div>
            <div className="text-sm text-muted-foreground">{label}</div>
          </Link>
        ))}
      </div>
      <div>
        <h2 className="font-display font-bold text-xl mb-4">{t("portal.projects")}</h2>
        <div className="space-y-3">
          {(d?.projects || []).map((p) => (
            <Link key={p.id} to={`/portal/projects/${p.id}`} className="surface p-5 flex items-center justify-between hover:border-primary transition-colors" data-testid={`dash-project-${p.id}`}>
              <div>
                <div className="font-semibold">{p.name}</div>
                <div className="text-sm text-muted-foreground capitalize">{sl(p.status)}</div>
              </div>
              <div className="w-40">
                <div className="flex justify-between text-xs mb-1"><span>{t("portal.progress")}</span><span>{p.progress}%</span></div>
                <div className="h-2 rounded-full bg-secondary overflow-hidden"><div className="h-full bg-primary" style={{ width: `${p.progress}%` }} /></div>
              </div>
            </Link>
          ))}
          {(!d?.projects || d.projects.length === 0) && <p className="text-muted-foreground text-sm">{t("common.none")}</p>}
        </div>
      </div>
    </div>
  );
}
